import React, {Component} from 'react';
class ChampionImage extends Component{
    render() {
        if(this.props.name != null) {
            let myName = "";
            let isTftPrefix = false;
            if(this.props.name instanceof Object) {
                myName = this.props.name.name;
            } else {
                myName = this.props.name;
            }
            if(myName.indexOf('_') > -1) {
                // tft_
                isTftPrefix = true;
            }
            let title = "";
            let myImage = `https://raw.communitydragon.org/latest/game/assets/characters/${myName.toLowerCase()}/hud/${myName.toLowerCase()}_square${isTftPrefix ? '.tft_set7':'_0'}.png`
            if(myName.split('_')[1] === "DragonBlue") {
                myImage = `https://raw.communitydragon.org/latest/game/assets/characters/tft7_dragonblue/hud/tft7_miragedragon_square.tft_set7.png`
            }
            if(myName.split('_')[1] === "DragonGold") {
                myImage = `https://raw.communitydragon.org/latest/game/assets/characters/tft7_dragongold/hud/tft7_shimmerscaledragon_square.tft_set7.png`
            }
            if(myName.split('_')[1] === "DragonGreen") {
                myImage = `https://raw.communitydragon.org/latest/game/assets/characters/tft7_dragongreen/hud/tft7_jadedragon_square.tft_set7.png`
            }
            if(myName.split('_')[1] === "DragonPurple") {
                myImage = `https://raw.communitydragon.org/latest/game/assets/characters/tft7_dragonpurple/hud/tft7_whispersdragon_square.tft_set7.png`
            }
            if(myName.split('_')[1] === "TrainerDragon") {
                myImage = `/champion/tft7_nomsy.png`
                title = "Nomsy"
            } else {
                title = myName.split('_')[1]
            }

            return (<img title={title} alt={title} className={`${this.props.size == null ? 'unit': 'unit-large'} rounded-full`} src={myImage}/>)
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default ChampionImage